export default "__VITE_ASSET__BSQ5l3f7__"